// 登录请求
import { getRequest,postRequest } from '../tools/ajax.js'



const OrganizationList = params => postRequest('/api/pc/Organization/OrganizationList', params);
const deleteOrganization = params => postRequest('/api/pc/Organization/ChangeStatus', params);
const addOrganization = params => postRequest('/api/pc/Organization/AddOrganization', params);
const editOrganization = params => postRequest('/api/pc/Organization/UpdateOrganization', params);
const pidOrganization = params => getRequest('/api/pc/Organization/GetOrganization', params);

const searchMenuList = params => postRequest('/api/pc/Menu/MenuList', params);
const deleteMenuList = params => postRequest('/api/pc/Menu/ChangeStatus', params);

const updateMenuList = params => postRequest('/api/pc/Menu/UpdateMenu', params);
const pidMenuList = params => getRequest('/api/pc/Menu/GetMenu', params);

const addMenuList = params => postRequest('/api/pc/Menu/AddMenu', params);
const searchMemberList = params => postRequest('/api/pc/Member/MemberList', params);
const deleteMemberList = params => postRequest('/api/pc/Member/ChangeStatus', params);
const updateMemberList = params => postRequest('/api/pc/Member/UpdateMember', params);
const addMemberList = params => postRequest('/api/pc/Member/AddMember', params);
const updatePassword = params => postRequest('/api/pc/Member/ChangePassword', params);
const ResetPassword = params => postRequest('/api/pc/Member/ResetPassword', params);
const UploadHandbook = params => postRequest('/api/pc/Member/UploadHandbook', params);
const ExportHandbook = params => postRequest('/api/pc/Member/ExportHandbook', params);
const UserDelete = params => postRequest('/api/pc/Member/UserDelete', params);

export {
    OrganizationList,
    deleteOrganization,
    addOrganization,
    editOrganization,
    searchMenuList,
    deleteMenuList,
    updateMenuList,
    addMenuList,
    searchMemberList,
    deleteMemberList,
    updateMemberList,
    addMemberList,
    updatePassword,
    pidOrganization,
    pidMenuList,
    ResetPassword,
    UploadHandbook,
    ExportHandbook,
    UserDelete,
} 